module.exports = __webpack_public_path__ + "static/media/visa-icon.a6ef48f7.svg";